import React, { useContext } from 'react';
import moment from 'moment';
import { groupBy, uniqueId, isEmpty } from 'lodash';
import noResultsSrc from 'images/content_no_results.svg';
import { BlankSlate, Description } from 'components/_shared/blank_slate';
import { Spinner } from 'ui';
import { FilterContext } from 'components/shared/FilterContext/index';
import { routes } from 'constants/config';
import DateFormat from 'constants/date_format';
import ActivityFeedDateContainer from './ActivityFeedDateContainer';
import FilteredRequest from '../_shared/FilteredRequest';

const NoResults = ({ description }) => (
  <BlankSlate>
    <img className="mw-300 mb-32" src={noResultsSrc} alt={description} />
    <Description>{description}</Description>
  </BlankSlate>
);

const ActivityFeedContainer = ({ i18n }) => {
  const { params: filters } = useContext(FilterContext);
  const hasDateFilter = filters.start_date || filters.end_date;
  if (hasDateFilter) {
    return (
      <NoResults
        description={t('insights.activity_feed.cannot_filter_by_date')}
      />
    );
  }

  const getActivitiesByDate = data =>
    groupBy(data.latest_activities, activity =>
      moment(activity.timestamp).startOf('day').format(DateFormat.LONG),
    );

  return (
    <FilteredRequest url={routes.INSIGHTS.LATEST_ACTIVITIES}>
      {({ data, loading, error }) => (
        <div>
          {error && <span className="ff-ss">{i18n.error}</span>}
          {loading && !error && (
            <span className="ff-ss">
              <Spinner color="darker" className="mr-4" />
              {i18n.loading}
            </span>
          )}
          {!loading && !error && data && isEmpty(data.latest_activities) && (
            <NoResults
              description={t(
                'insights.activity_feed.no_activity_with_groups_filter',
              )}
            />
          )}
          {!loading && !error && data && !isEmpty(data.latest_activities) && (
            <div>
              {Object.keys(getActivitiesByDate(data)).map(date => (
                <ActivityFeedDateContainer
                  key={uniqueId()}
                  i18n={i18n.activity_status}
                  date={date}
                  activitiesByDate={getActivitiesByDate(data)}
                />
              ))}
            </div>
          )}
        </div>
      )}
    </FilteredRequest>
  );
};

export default ActivityFeedContainer;
